export const GANTT = {
  // Bottom toolbar
  BOTTOM_TOOLBAR: 'gantt-bottom-toolbar',
  BOTTOM_TOOLBAR_TEXT: 'gantt-bottom-toolbar-text',
  DAYS_LIST_ITEM: 'gantt-bottom-toolbar-days-list-item',
  ZOOM_IN_BUTTON: 'gantt-bottom-toolbar-zoom-in-button',
  ZOOM_OUT_BUTTON: 'gantt-bottom-toolbar-zoom-out-button',
  SCROLL_TO_TODAY_BUTTON: 'gantt-bottom-toolbar-scroll-to-today-button',
  FIT_TO_SCREEN_BUTTON: 'gantt-bottom-toolbar-fit-to-screen-button',

  // Display options
  GANTT_POPUP_CONTROL: 'gantt-popup-control',
  GANTT_MENU_ITEM: 'gantt-menu-item',
  DISPLAY_OPTION_SWITCH_NAME: 'gantt-display-option-switch-name',
  DISPLAY_DURATION: 'gantt-display-duration',
  DISPLAY_TOTAL_FLOAT: 'gantt-display-total-float',
  DISPLAY_LAG: 'gantt-display-lag',
  DISPLAY_OPTION_SWITCH_ROWS: 'gantt-display-option-switch-rows',
  DISPLAY_OPTION_SWITCH_ROWS_ACTIVITY: 'gantt-display-option-switch-rows-activity',
  DISPLAY_OPTION_SWITCH_ROWS_GROUP: 'gantt-display-option-switch-rows-group',
  DISPLAY_OPTION_SWITCH_ROWS_MILESTONE: 'gantt-display-option-switch-rows-milestone',
  DISPLAY_OPTION_SWITCH_ROWS_TASK: 'gantt-display-option-switch-rows-task',
  DISPLAY_DATA_DATE_LINE: 'gantt-display-data-date-line',
  DISPLAY_HORIZONTAL_SIGHT_LINES: 'gantt-display-horizontal-sight-lines',
  DISPLAY_TODAYS_DATE_LINE: 'gantt-display-todays-date-line',
  DISPLAY_VERTICAL_SIGHT_LINES: 'gantt-display-vertical-sight-lines',
  GANTT_POPUP_TITLE: 'gantt-popup-title',
  GANTT_POPUP_TITLE_ACTIVITY_BAR_COLORS: 'gantt-popup-title-activity-bar-colors',
  GANTT_POPUP_TITLE_SHOW_ROWS: 'gantt-popup-title-show-rows',
  GANTT_POPUP_TITLE_OTHER_SETTINGS: 'gantt-popup-title-other-settings',
  ACTIVITY_TASK_BAR: 'gantt-activity-task-bar',

  // PDF
  PDF_FOOTER: 'gantt-pdf-footer',
  PDF_FOOTER_TEXT: 'gantt-pdf-footer-text',

  // Navigation
  NAV_RELATIONSHIPS_BUTTON: 'gantt-nav-relationships-button',
  NAV_RELATIONSHIPS_ICON: 'gantt-nav-relationships-icon',
  NAV_SETTINGS_ICON: 'gantt-nav-settings-icon',

  // Controls
  /** Legacy single toggle (rendered when `enableGanttLayoutToggle` is OFF). */
  TOGGLE_GRID_BUTTON: 'gantt-toggle-grid-button',
  /**
   * PRD-26889 two-button layout controls (flag ON). Buttons are binary:
   * `<<` hides the grid (apply-layout renders the 1 px sentinel while
   * preserving stored width); `>>` snaps the visible width to its ceiling
   * (`container - indexCol - scrollbar`). The resizer handles all
   * intermediate widths. Buttons hide when the action would be a no-op.
   */
  GANTT_HIDE_LEFT_PANE_BUTTON: 'gantt-hide-left-pane-button',
  GANTT_EXPAND_LEFT_PANE_BUTTON: 'gantt-expand-left-pane-button',
  GANTT_LAYOUT_CONTROLS: 'gantt-layout-controls',
  EDIT_COLUMNS_BUTTON: 'gantt-edit-columns-button',
  MORE_MENU_BUTTON: 'gantt-more-menu-button',
  TOGGLE_RELATIONSHIPS_BUTTON: 'gantt-toggle-relationships-button',

  // Context menu
  COPY_LINK_TO_ELEMENT: 'gantt-copy-link-to-element',
  CONTEXT_MENU_ADD_ACTIVITY: 'gantt-context-menu-add-activity',
  CONTEXT_MENU_ADD_MILESTONE: 'gantt-context-menu-add-milestone',
  CONTEXT_MENU_NAVIGATE_TO_CANVAS: 'gantt-context-menu-navigate-to-canvas',
  CONTEXT_MENU_NAVIGATE_TO_TABLE: 'gantt-context-menu-navigate-to-table',
  CONTEXT_MENU_INSPECT_PATH: 'gantt-context-menu-inspect-path',
  CONTEXT_MENU_SHOW_RELATIONSHIPS: 'gantt-context-menu-show-relationships',
  CONTEXT_MENU_SHOW_STATUS: 'gantt-context-menu-show-status',
  CONTEXT_MENU_SHOW_MINI_TABLE: 'gantt-context-menu-show-mini-table',
  CONTEXT_MENU_ADD_NOTES_COMMENTS: 'gantt-context-menu-add-notes-comments',
  CONTEXT_MENU_SHOW_CHANGELOG: 'gantt-context-menu-show-changelog',
  CONTEXT_MENU_GROUP_COLOR: 'gantt-context-menu-group-color',
  CONTEXT_MENU_SHOW_GROUPS_TO_LEVEL: 'gantt-context-menu-show-groups-to-level'
} as const;
